export default {
  styleOverrides: {
    root: {
      color: "var(--theme-primary) !important",
      opacity: "100%"
    }
  }
};
